import Alodokter from "../utils/Alodokter";

export default class GeneralAnalytics {
    // exmaple faq analytics
    static faq(item_category,value) {
        Alodokter.sendEventGA4({
            element: "faq",
            item_category: item_category,
            value: value,
            event: "click_element",
        });
    }

    static selectCategory(scientific_category, item_category) {
        Alodokter.sendEventGA4({
            scientific_category: scientific_category,
            item_category: item_category,
            event: "select_category",
        });
    }
}
